import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Button } from '@wit-support/ui';
import { useZodFormContext } from './context.js';
export const SubmitButton = React.forwardRef(({ children, pendingLabel = 'Submitting\u2026', disabled, variant = 'primary', ...props }, ref) => {
    const { form } = useZodFormContext();
    const submitting = form.formState.isSubmitting;
    return (_jsx(Button, { ref: ref, type: "submit", variant: variant, disabled: disabled || submitting, ...props, children: submitting ? pendingLabel : children }));
});
SubmitButton.displayName = 'SubmitButton';
//# sourceMappingURL=submit-button.js.map